import { PencilIcon } from "@heroicons/react/20/solid";
import { Button, ButtonIntent, ButtonState } from "src/components/Button";
import type { MapState } from "src/types/MapState";
import { ToolSelection } from "src/types/MapState";
import { useTranslation } from "src/translations";

export function CreateButton({ mapState, onClick }: { mapState: MapState; onClick: () => void }) {
  const { selectedTool: mode } = mapState;
  const { t } = useTranslation();
  return (
    <Button
      title={t("toolbox.create")}
      Icon={PencilIcon}
      onClick={onClick}
      intent={ButtonIntent.SELECT}
      state={mode.value.id === ToolSelection.CREATE ? ButtonState.ACTIVE : ButtonState.NONE}
    />
  );
}
